"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[809,749],{

/***/ 3749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BTCValueCard": function() { return /* binding */ BTCValueCard; },
/* harmony export */   "BlogCard": function() { return /* binding */ BlogCard; },
/* harmony export */   "CalculatorCard": function() { return /* binding */ CalculatorCard; },
/* harmony export */   "GraphCard": function() { return /* binding */ GraphCard; },
/* harmony export */   "ImageBGCard": function() { return /* binding */ ImageBGCard; },
/* harmony export */   "LatestBlogCard": function() { return /* binding */ LatestBlogCard; },
/* harmony export */   "OutputCard": function() { return /* binding */ OutputCard; },
/* harmony export */   "WarningCard": function() { return /* binding */ WarningCard; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71383);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19010);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46133);



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;


 // TODO: green/red text

var BTCValueCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  box-shadow: ", ";\n  width: 100%;\n  min-width: 25rem;\n  align-items: center;\n  justify-content: space-between;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 0 2rem;\n  background: ", ";\n  @media screen and (max-width: ", ") {\n    flex: 1;\n  }\n  @media screen and (max-width: ", ") {\n    height: 100px;\n  }\n  min-height: 100px;\n  height: 100%;\n  box-sizing: border-box;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.shadow;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.glassEffect.blur;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.glassEffect.blur;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.glassBackground;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.lg.maxWidth;
});
var CalculatorCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  box-shadow: ", ";\n  flex-direction: column;\n  align-items: center;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1rem;\n  background: ", ";\n  box-sizing: border-box;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.shadow;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.glassEffect.blur;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.glassEffect.blur;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.glassBackground;
});
var GraphCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  overflow: hidden;\n  box-shadow: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1rem;\n  background: ", ";\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  .recharts-wrapper > svg.recharts-surface {\n    margin-top: 15px;\n  }\n  @media screen and (max-width: ", ") {\n    .recharts-wrapper > svg.recharts-surface {\n      margin-top: 25px;\n    }\n  }\n\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.shadow;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.glassEffect.blur;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.glassEffect.blur;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.glassBackground;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.breakpoints.sm.maxWidth;
});
var OutputCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  box-shadow: ", ";\n  max-height: 8rem;\n  min-width: 20rem;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 1.5rem 1rem;\n  background: ", ";\n\n  @media screen and (max-width: ", ") {\n    margin: ", ";\n  }\n  box-sizing: border-box;\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.colors.shadow;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.glassEffect.blur;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.glassEffect.blur;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.glassBackground;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.breakpoints.lg.minWidth;
}, function (_ref25) {
  var $margin = _ref25.$margin;
  return $margin ? $margin : 'initial';
});
var LatestBlogCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].a */ .ZP.a(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: flex-end;\n  position: relative;\n  min-height: 100%;\n  backdrop-filter: blur(", ");\n  -webkit-backdrop-filter: blur(", ");\n  border-radius: ", ";\n  padding: 0;\n  background: ", ";\n  overflow: hidden;\n\n  text-decoration: none;\n\n  @media screen and (max-width: ", ") {\n    margin: ", ";\n  }\n  box-sizing: border-box;\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.glassEffect.blur;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.glassEffect.blur;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.glassEffect.borderRadius;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.colors.glassBackground;
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.breakpoints.lg.minWidth;
}, function (_ref31) {
  var $margin = _ref31.$margin;
  return $margin ? $margin : 'initial';
});
var WarningCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  background: ", ";\n  padding: 1rem;\n  color: black;\n  border-radius: 5px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  justify-content: space-between;\n\n  > p {\n    margin: 0;\n    font-weight: bold;\n  }\n"])), function (_ref32) {
  var theme = _ref32.theme;
  return theme.colors.secondaryGradient;
});
var ImageBGCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(function (_ref33) {
  var _ref34;

  var _ref33$theme = _ref33.theme,
      colors = _ref33$theme.colors,
      glassEffect = _ref33$theme.glassEffect,
      breakpoints = _ref33$theme.breakpoints,
      $img = _ref33.$img;
  return _ref34 = {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    width: '100%',
    height: '100%',
    borderRadius: glassEffect.borderRadius,
    transition: 'box-shadow 0.56s ease-in-out',
    backgroundColor: colors.cardBackground,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    backgroundImage: "url(".concat($img, ")")
  }, (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref34, '&:hover', {
    cursor: 'pointer',
    boxShadow: '0 24px 38px 3px rgba(0,0,0,0.14), 0 9px 46px 8px rgba(0,0,0,0.12), 0 11px 15px -7px rgba(0,0,0,0.2)'
  }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref34, "@media screen and (max-width: ".concat(breakpoints.sm.maxWidth, ")"), {
    minHeight: '20rem'
  }), _ref34;
});
var BlogCard = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(["\n  box-shadow: ", ";\n  width: 100%;\n  max-width: 33rem;\n  min-width: 33rem;\n  max-height: 45rem;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  border-radius: 5px;\n  padding: 2rem;\n  gap: 2rem;\n  cursor: pointer;\n  @media screen and (max-width: ", ") {\n    max-width: 100%;\n  }\n"])), function (_ref35) {
  var theme = _ref35.theme;
  return theme.colors.shadow;
}, function (_ref36) {
  var theme = _ref36.theme;
  return theme.colors.glassBackground;
}, function (_ref37) {
  var theme = _ref37.theme;
  return theme.breakpoints.sm.maxWidth;
});

/***/ }),

/***/ 68219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "HU": function() { return /* binding */ FooterText; },
/* harmony export */   "O": function() { return /* binding */ CardParagraph; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* unused harmony export FooterLink */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46133);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;


var H1 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h1 */ .ZP.h1(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: 1.5rem;\n  text-align: ", ";\n  font-size: ", ";\n  @media screen and (max-width: ", ") {\n    font-size: ", ";\n  }\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.headingFontFamily;
}, function (_ref2) {
  var $textAlign = _ref2.$textAlign;
  return $textAlign ? $textAlign : 'initial';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.desktopFontSize.title;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.mobileFontSize.title;
}, function (_ref6) {
  var theme = _ref6.theme,
      $brand = _ref6.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: ", ";\n  font-size: ", ";\n  position: ", ";\n  left: ", ";\n  color: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.headingFontFamily;
}, function (_ref8) {
  var $marginBottom = _ref8.$marginBottom;
  return $marginBottom || '1.5rem';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.fontSizes[2];
}, function (_ref10) {
  var $sticky = _ref10.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref11) {
  var $sticky = _ref11.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref12) {
  var theme = _ref12.theme,
      $brand = _ref12.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.headingFontFamily;
}, function (_ref14) {
  var $color = _ref14.$color;
  return $color ? $color : 'inherit';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.fontSizes[4];
});
var H4 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h4 */ .ZP.h4(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: ", ";\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.headingFontFamily;
}, function (_ref17) {
  var $padding = _ref17.$padding;
  return $padding ? $padding : 'initial';
}, function (_ref18) {
  var theme = _ref18.theme,
      $brand = _ref18.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.typography.fontSizes[5];
}, function (_ref20) {
  var $ellipsis = _ref20.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref21) {
  var $ellipsis = _ref21.$ellipsis;
  return $ellipsis && 2;
}, function (_ref22) {
  var $ellipsis = _ref22.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref23) {
  var $ellipsis = _ref23.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref24) {
  var $ellipsis = _ref24.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref25) {
  var $ellipsis = _ref25.$ellipsis;
  return $ellipsis && '3.4rem';
});
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  text-align: ", ";\n  padding: ", ";\n  margin: initial;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: calc(\n    ", " * 2\n  );\n  color: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref27) {
  var $textAlign = _ref27.$textAlign;
  return $textAlign ? $textAlign : 'left';
}, function (_ref28) {
  var $padding = _ref28.$padding;
  return $padding ? $padding : '2rem 0';
}, function (_ref29) {
  var $fontWeight = _ref29.$fontWeight;
  return $fontWeight ? $fontWeight : 'initial';
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.typography.fontSizes[5];
}, function (_ref31) {
  var theme = _ref31.theme,
      $lineHeight = _ref31.$lineHeight;
  return $lineHeight ? $lineHeight : theme.typography.fontSizes[5];
}, function (_ref32) {
  var theme = _ref32.theme,
      $brand = _ref32.$brand,
      $color = _ref32.$color;
  return $brand ? theme.colors.primary : theme.colors[$color || 'text'];
}, function (_ref33) {
  var $ellipsis = _ref33.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref34) {
  var $ellipsis = _ref34.$ellipsis;
  return $ellipsis && 4;
}, function (_ref35) {
  var $ellipsis = _ref35.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref36) {
  var $ellipsis = _ref36.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref37) {
  var $ellipsis = _ref37.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref38) {
  var $ellipsis = _ref38.$ellipsis;
  return $ellipsis && '9.7rem';
});
var Summary = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: ", ";\n  max-width: 100vw;\n  overflow-wrap: break-word;\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n"])), function (_ref39) {
  var $textAlign = _ref39.$textAlign;
  return $textAlign ? $textAlign : 'center';
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.typography.fontSizes[3];
});
var CardParagraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  font-size: ", ";\n  line-height: calc(", " * 1.25);\n  color: ", ";\n"])), function (_ref42) {
  var theme = _ref42.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.typography.fontSizes[5];
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.typography.fontSizes[5];
}, function (_ref45) {
  var $color = _ref45.$color,
      theme = _ref45.theme;
  return $color ? $color : theme.colors.text;
});
var FooterLink = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a */ .ZP.a(_templateObject8 || (_templateObject8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref46) {
  var theme = _ref46.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref47) {
  var theme = _ref47.theme,
      $brand = _ref47.$brand;
  return $brand ? theme.colors.linkColours.alt : theme.colors.text;
}, function (_ref48) {
  var theme = _ref48.theme,
      $brand = _ref48.$brand;
  return $brand ? theme.colors.linkColours.altHover : theme.colors.text;
});
var FooterText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject9 || (_templateObject9 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: center;\n  max-width: 800px;\n  line-height: 1.2;\n  a {\n    font-family: ", ";\n    color: ", ";\n  }\n"])), function (_ref49) {
  var theme = _ref49.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref50) {
  var theme = _ref50.theme;
  return theme.colors.primary;
});

/***/ }),

/***/ 9809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71383);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19010);
/* harmony import */ var components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68219);
/* harmony import */ var components_atoms_Cards__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3749);
/* harmony import */ var utils_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91851);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46133);
/* harmony import */ var utils_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92442);
/* harmony import */ var components_content_calculator_calculationContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93138);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);



var _excluded = ["label", "value", "currency", "precision"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var StyledComposition = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_1__/* .Composition */ .fS)(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  overflow-x: scroll;\n  scrollbar-color: ", ";\n\n  @media screen and (min-width: ", ") {\n    overflow-x: hidden;\n    overflow: visible;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.scrollbar;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.sm.minWidth;
});
var StatsContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  row-gap: 4rem;\n  column-gap: 3rem;\n  @media screen and (max-width: ", ") {\n    padding-bottom: 1rem;\n  }\n  @media screen and (min-width: ", ") {\n    width: initial;\n    flex-direction: column;\n    height: 100%;\n    justify-content: flex-start;\n  }\n  @media screen and (min-width: ", ") and (max-width: ", ") {\n    justify-content: space-between;\n  }\n  @media screen and (min-width: ", ") {\n    justify-content: space-between;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm.minWidth;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.sm.minWidth;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.xl.minWidth;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.xl.minWidth;
});

var SingleStat = function SingleStat(_ref8) {
  var label = _ref8.label,
      value = _ref8.value,
      colour = _ref8.colour;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(components_atoms_Cards__WEBPACK_IMPORTED_MODULE_3__.OutputCard, {
    minHeight: "66px",
    $margin: "0",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
      $padding: "initial",
      $lineHeight: "initial",
      children: label
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__.H3, {
      $color: colour,
      children: value
    })]
  });
};

var CurrencyStat = function CurrencyStat(_ref9) {
  var label = _ref9.label,
      value = _ref9.value,
      currency = _ref9.currency,
      _ref9$precision = _ref9.precision,
      precision = _ref9$precision === void 0 ? undefined : _ref9$precision,
      options = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref9, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(SingleStat, {
    label: label,
    value: value ? (0,utils_currency__WEBPACK_IMPORTED_MODULE_4__/* .toCurrencyString */ .mr)(value, currency, _objectSpread({
      maximumFractionDigits: precision
    }, options)) : ''
  });
};

var statsArea = "\n    stats\n";

var SingleStats = function SingleStats(_ref10) {
  var singleStatsProps = _ref10.singleStatsProps;

  var _useCalculation = (0,components_content_calculator_calculationContext__WEBPACK_IMPORTED_MODULE_5__/* .useCalculation */ .C)(),
      currency = _useCalculation.currency,
      singleStatData = _useCalculation.singleStatData,
      isSatoshis = _useCalculation.isSatoshis;

  var _ref11 = singleStatData || {},
      _ref11$totalValue = _ref11.totalValue,
      totalValue = _ref11$totalValue === void 0 ? 0 : _ref11$totalValue,
      _ref11$totalInvested = _ref11.totalInvested,
      totalInvested = _ref11$totalInvested === void 0 ? 0 : _ref11$totalInvested,
      _ref11$averageCryptoP = _ref11.averageCryptoPrice,
      averageCryptoPrice = _ref11$averageCryptoP === void 0 ? 0 : _ref11$averageCryptoP,
      _ref11$investmentRetu = _ref11.investmentReturnPercentage,
      investmentReturnPercentage = _ref11$investmentRetu === void 0 ? 0 : _ref11$investmentRetu,
      _ref11$purchasingPowe = _ref11.purchasingPower,
      purchasingPower = _ref11$purchasingPowe === void 0 ? null : _ref11$purchasingPowe;

  var snipPercentage = function snipPercentage(value) {
    var calcVal = Number(value);
    if (calcVal > -0.01 && calcVal < 0) calcVal = 0;
    return calcVal;
  };

  var formattedPercentage = function formattedPercentage(value) {
    return snipPercentage(value).toLocaleString(undefined, {
      maximumFractionDigits: 2
    });
  };

  var investmentReturn = function investmentReturn(investmentReturnPercent) {
    if (!investmentReturnPercent || investmentReturnPercent === 0) return '';
    var value = formattedPercentage(investmentReturnPercent);
    return investmentReturnPercent > 0 ? "+".concat(value, "%") : "".concat(value, "%");
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledComposition, {
    areas: statsArea,
    gap: 2,
    height: "100%",
    children: function children(_ref12) {
      var Stats = _ref12.Stats;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(Stats, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StatsContainer, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(CurrencyStat, {
              label: singleStatsProps.totalInvestedLabel,
              value: totalInvested,
              currency: currency,
              precision: 0
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(CurrencyStat, {
              label: singleStatsProps.totalValueLabel,
              value: totalValue,
              currency: currency,
              precision: 0
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(SingleStat, {
              colour: (0,utils_utils__WEBPACK_IMPORTED_MODULE_10__/* .colorFromValue */ .HV)(snipPercentage(investmentReturnPercentage)),
              label: singleStatsProps.investmentReturnLabel,
              value: investmentReturn(investmentReturnPercentage) || ''
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(CurrencyStat, {
              label: isSatoshis ? singleStatsProps.averageSatoshiPriceLabel : singleStatsProps.averageBTCPriceLabel,
              value: averageCryptoPrice,
              currency: currency,
              precision: isSatoshis ? 8 : 0,
              maximumSignificantDigits: averageCryptoPrice > 10 ? undefined : 3,
              minimumFractionDigits: 0,
              maximumFractionDigits: averageCryptoPrice > 10 ? 0 : 8
            }), purchasingPower !== null && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(CurrencyStat, {
              label: singleStatsProps.purchasingPowerLabel,
              value: Math.round(purchasingPower).toString(),
              currency: currency,
              precision: 0,
              maximumSignificantDigits: undefined,
              minimumFractionDigits: 0,
              maximumFractionDigits: 2
            })]
          })
        })
      });
    }
  });
};

/* harmony default export */ __webpack_exports__["default"] = (SingleStats);

/***/ })

}]);